import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { IAccountActivationRequest } from '../models/account-activation-request.model';
import { IAccountActivationResponse } from '../models/account-activation-response.model';
import { KeycloakService } from 'keycloak-angular';
import { KeycloakProfile } from 'keycloak-js';
import { RouterStateSnapshot } from '@angular/router';
import { IPasswordResetRequest } from '../models/password-reset-request.model';
import { IPasswordResetResponse } from '../models/password-reset-response.model';
import { IPasswordResetTokenRequest } from '../models/password-reset-token-request.model';
import { IPasswordResetTokenResponse } from '../models/password-reset-token-response.model';
import { IResendActivationTokenRequest } from '../models/resend-activation-token-request.model';
import { UserType } from '../models/user-profile-model';
import { IGetProfileResponse } from '../models/profile-response.model';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private http: HttpClient, private keycloak: KeycloakService) {}

  logout() {
    this.keycloak.logout();
  }

  isLoggedIn() {
    return this.keycloak.isLoggedIn();
  }

  userProfile(): Promise<KeycloakProfile> {
    return this.keycloak.loadUserProfile();
  }

  userRoles(): string[] {
    return this.keycloak.getUserRoles();
  }

  redirectToLogin(state: RouterStateSnapshot) {
    return this.keycloak.login({
      redirectUri: window.location.origin + state.url,
    });
  }

  getUserDetailsById(id: string) {
    const headers: HttpHeaders = new HttpHeaders({
      userId: id,
      userType: UserType.OTHER,
    });
    const url = `${environment.apiGatewayBaseUrl}/auth/v1/user/user-by-id`;
    return this.http.get<IGetProfileResponse>(url, { headers });
  }

  logoutUser() {
    this.keycloak.logout();
  }
}
